import { ActivityFormContext } from '@/contexts/ActivityFormContext';
import { Box, Skeleton, Stack, Typography, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

type AssistantSuggestionProps = {
  title?: string | null;
  onAccept?: () => void;
  onDecline?: () => void;
  autoClose?: boolean;
  loading?: boolean;
  error?: boolean;
  children: React.ReactNode;
};

const AssistantSuggestion = (props: AssistantSuggestionProps) => {
  const { t } = useTranslation();
  const autoClose = props.autoClose ?? true;
  const { palette } = useTheme();
  const formHandler = useContext(ActivityFormContext);

  return (
    <>
      {props.title && (
        <Typography variant="body2" color={palette.grey[50]} sx={{ fontWeight: 'bold' }}>
          {props.title}
        </Typography>
      )}
      {props.loading ? (
        <Stack spacing={1}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
        </Stack>
      ) : props.error ? (
        <Typography variant="body2">{t('No suggestions available')}</Typography>
      ) : (
        props.children
      )}
      {!props.loading && !props.error && (props.onAccept || props.onDecline) && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 1.5 }}>
          <Typography
            variant="body2"
            sx={{
              cursor: 'pointer',
              color: palette.mode === 'dark' ? palette.grey[300] : palette.grey[200],
            }}
            onClick={() => {
              props.onDecline?.();
              if (autoClose) {
                formHandler.setAssistantAnchorEl?.(null);
              }
            }}
          >
            {t('No thanks')}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'bold',
              cursor: 'pointer',
              color: palette.mode === 'dark' ? palette.grey[200] : palette.grey[50],
            }}
            onClick={() => {
              props.onAccept?.();
              if (autoClose) {
                formHandler.setAssistantAnchorEl?.(null);
              }
            }}
          >
            {t('Use')}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default AssistantSuggestion;
